
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { myStudyMenu } from '@xt/client/dataSource/my/index'
import MyLayout from '../views/MyLayout/index.vue'

@Component({
  components: { MyLayout }
})
export default class extends Vue {
  get myStudyMenu() {
    return myStudyMenu
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
